import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import PublicCatalog from "@/pages/PublicCatalog";
import PublicKeepCheck from "@/pages/PublicKeepCheck";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import PosSync from "@/pages/PosSync";
import ProductList from "@/pages/ProductList";
import ProductLabels from "@/pages/ProductLabels";
import StockOut from "@/pages/StockOut";
import MasterSimple from "@/pages/MasterSimple";
import CustomerReturns from "@/pages/CustomerReturns";
import RestockPlanning from "@/pages/RestockPlanning";
import PublicStock from "@/pages/PublicStock";
import Opname from "@/pages/Opname";
import Warehouses from "@/pages/Warehouses";
import Tailor from "@/pages/Tailor";
import Receiving from "@/pages/Receiving";
import QC from "@/pages/QC";
import Stock from "@/pages/Stock";
import Reconciliation from "@/pages/Reconciliation";
import Transfers from "@/pages/Transfers";
import TransferCreate from "@/pages/TransferCreate";
import WarehouseMonitor from "@/pages/WarehouseMonitor";
import ImportPurchase from "@/pages/ImportPurchase";
import ImportHistory from "@/pages/ImportHistory";
import StockMovement from "@/pages/StockMovement";
import Reports from "@/pages/Reports";
import BusinessIntelligence from "@/pages/BusinessIntelligence";
import Users from "@/pages/Users";
import Roles from "@/pages/Roles";
import PermissionMatrix from "@/pages/PermissionMatrix";
import MarketplaceSettlement from "@/pages/MarketplaceSettlement";
import DailyRecap from "@/pages/DailyRecap";
import KeepRecap from "@/pages/KeepRecap";
import BcaReconciliation from "@/pages/BcaReconciliation";
import MarketplaceShippingReconciliation from "@/pages/MarketplaceShippingReconciliation";
import ReconciliationControlCenter from "@/pages/ReconciliationControlCenter";
import OnlineReportCoverage from "@/pages/OnlineReportCoverage";
import MarketplaceMapping from "@/pages/MarketplaceMapping";
import VariantMapping from "@/pages/VariantMapping";
import RabRequests from "@/pages/RabRequests";
import OnlineSales from "@/pages/OnlineSales";
import Settings from "@/pages/Settings";
import StockHistory from "@/pages/StockHistory";
import UserActivity from "@/pages/UserActivity";
import Suppliers from "@/pages/Suppliers";
import PurchaseRequests from "@/pages/PurchaseRequests";
import PurchaseOrders from "@/pages/PurchaseOrders";
import PurchaseOrderCreate from "@/pages/PurchaseOrderCreate";
import PurchasePO from "@/pages/PurchasePO";
import ComingSoon from "@/pages/ComingSoon";
import Keep from "@/pages/Keep";
import KeepCreate from "@/pages/KeepCreate";
import PreOrderQuota from "@/pages/PreOrderQuota";
import PreOrderBatches from "@/pages/PreOrderBatches";
import PreOrderReady from "@/pages/PreOrderReady";
import PreOrderWarehouse from "@/pages/PreOrderWarehouse";
import CreateKeepPO from "@/pages/CreateKeepPO";
import PreOrderOverview from "@/pages/PreOrderOverview";
import PreOrderAnalysis from "@/pages/PreOrderAnalysis";
import PreOrderProduction from "@/pages/PreOrderProduction";
import Customers from "@/pages/Customers";
import CustomerGroups from "@/pages/CustomerGroups";
import Sales from "@/pages/Sales";
import CreateSale from "@/pages/CreateSale";
import ShippingSale from "@/pages/ShippingSale";
import Bazar from "@/pages/Bazar";
import BazarCompare from "@/pages/BazarCompare";
import PaymentMethods from "@/pages/PaymentMethods";
import PrinterSettings from "@/pages/PrinterSettings";
import Fabrics from "@/pages/production/Fabrics";
import Accessories from "@/pages/production/Accessories";
import BOM from "@/pages/production/BOM";
import ProductionDashboard from "@/pages/production/ProductionDashboard";
import ProductionReport from "@/pages/production/ProductionReport";
import ProductionPlans, { PlanWizardPage } from "@/pages/production/ProductionPlans";
import MaterialPurchases from "@/pages/production/MaterialPurchases";
import RestockProposals from "@/pages/production/RestockProposals";
import Cutting from "@/pages/production/Cutting";
import ProductionOrders from "@/pages/production/ProductionOrders";
import ProductionKanban from "@/pages/production/ProductionKanban";
import ProductionReceiving from "@/pages/production/ProductionReceiving";
import ReceivingHub from "@/pages/production/ReceivingHub";
import ProductProductionHistory from "@/pages/production/ProductProductionHistory";
import WIP from "@/pages/production/WIP";
import FabricReturns from "@/pages/production/FabricReturns";
import Defect from "@/pages/Defect";
import KolManagement from "@/pages/KolManagement";
import DestyShipped from "@/pages/DestyShipped";
import PendingShipments from "@/pages/PendingShipments";
import OrderCancel from "@/pages/OrderCancel";
import HermesApiDocs from "@/pages/HermesApiDocs";
import ChatGptConnector from "@/pages/ChatGptConnector";
import UserGuide from "@/pages/UserGuide";
import OidcAuthorize from "@/pages/OidcAuthorize";
import AssetReport from "@/pages/AssetReport";

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/oidc/authorize" element={<OidcAuthorize />} />
          <Route path="/cek-stok" element={<PublicStock />} />
          <Route path="/katalog" element={<PublicCatalog />} />
          <Route path="/cek-keep" element={<PublicKeepCheck />} />
          <Route path="/" element={<P><Dashboard /></P>} />
          <Route path="/panduan" element={<P><UserGuide /></P>} />
          <Route path="/notifications" element={<P><ComingSoon title="Notification" /></P>} />
          <Route path="/marketplace" element={<P><ComingSoon title="Marketplace" /></P>} />
          <Route path="/tailor" element={<P><ComingSoon title="Tailor / Konveksi" /></P>} />
          <Route path="/ventedaily/online-sales" element={<P><OnlineSales /></P>} />
          <Route path="/ventedaily/desty-shipped" element={<P><DestyShipped /></P>} />
          <Route path="/ventedaily/daily-recap" element={<P><DailyRecap /></P>} />
          <Route path="/ventedaily/pending-shipments" element={<P><PendingShipments /></P>} />
          <Route path="/ventedaily/order-cancel" element={<P><OrderCancel /></P>} />
          <Route path="/ventedaily/hermes-docs" element={<P><HermesApiDocs /></P>} />
          <Route path="/ventedaily/chatgpt-connector" element={<P><ChatGptConnector /></P>} />
          <Route path="/ventedaily/shipping" element={<P><MarketplaceShippingReconciliation /></P>} />
          <Route path="/ventedaily/withdrawal" element={<P><ComingSoon title="Ventedaily Withdrawal" /></P>} />
          <Route path="/inventory/stock-in" element={<P><ComingSoon title="Stock In" /></P>} />
          <Route path="/inventory/stock-out" element={<P><StockOut /></P>} />
          <Route path="/inventory/defect" element={<P><Defect /></P>} />
          <Route path="/marketing/kol" element={<P><KolManagement /></P>} />
          <Route path="/products" element={<P><Products /></P>} />
          <Route path="/products/variant-mapping" element={<P><VariantMapping /></P>} />
          <Route path="/pos-sync" element={<P><PosSync /></P>} />
          <Route path="/product-list" element={<P><ProductList /></P>} />
          <Route path="/warehouses" element={<P><Warehouses /></P>} />
          <Route path="/tailor" element={<P><Tailor /></P>} />
          <Route path="/suppliers" element={<P><Suppliers /></P>} />
          <Route path="/purchase-requests" element={<P><PurchaseRequests /></P>} />
          <Route path="/purchase-orders" element={<P><PurchaseOrders /></P>} />
          <Route path="/purchase-orders/create" element={<P><PurchaseOrderCreate /></P>} />
          <Route path="/purchase-orders/:id/edit" element={<P><PurchaseOrderCreate /></P>} />
          <Route path="/purchase-po" element={<P><PurchasePO /></P>} />
          <Route path="/receiving" element={<P><Receiving /></P>} />
          <Route path="/qc" element={<P><QC /></P>} />
          <Route path="/stock" element={<P><Stock /></P>} />
          <Route path="/reconciliation" element={<P><Reconciliation /></P>} />
          <Route path="/transfers" element={<P><Transfers /></P>} />
          <Route path="/transfers/create" element={<P><TransferCreate /></P>} />
          <Route path="/warehouse/monitor" element={<P><WarehouseMonitor /></P>} />
          <Route path="/import-purchase" element={<P><ImportPurchase /></P>} />
          <Route path="/import-history" element={<P><ImportHistory /></P>} />
          <Route path="/movements" element={<P><StockMovement /></P>} />
          <Route path="/reports" element={<P><Reports /></P>} />
          <Route path="/reports/business-intelligence" element={<P><BusinessIntelligence /></P>} />
          <Route path="/finance/bca-reconciliation" element={<P><BcaReconciliation /></P>} />
          <Route path="/users" element={<P><Users /></P>} />
          <Route path="/roles" element={<P><Roles /></P>} />
          <Route path="/roles/matrix" element={<P><PermissionMatrix /></P>} />
          <Route path="/user-activity" element={<P><UserActivity /></P>} />
          <Route path="/settings" element={<P><Settings /></P>} />

          {/* Pengadaan */}
          <Route path="/pengadaan/approval" element={<P><ComingSoon title="Approval Pengadaan" /></P>} />
          <Route path="/pengadaan/monitoring" element={<P><ComingSoon title="Monitoring Supplier/Konveksi" /></P>} />
          {/* Penerimaan & QC */}
          <Route path="/qc/rework" element={<P><ComingSoon title="Rework" /></P>} />
          <Route path="/qc/reject" element={<P><ComingSoon title="Reject" /></P>} />
          {/* Sales */}
          <Route path="/sales" element={<P><Sales /></P>} />
          <Route path="/sales/create" element={<P><CreateSale /></P>} />
          <Route path="/sales/keep" element={<P><Keep /></P>} />
          <Route path="/sales/keep/recap" element={<P><KeepRecap /></P>} />
          <Route path="/sales/keep/create" element={<P><KeepCreate /></P>} />
          <Route path="/sales/keep/edit/:id" element={<P><KeepCreate /></P>} />
          <Route path="/sales/preorder" element={<P><PreOrderQuota /></P>} />
          <Route path="/sales/preorder-batches" element={<P><PreOrderBatches /></P>} />
          <Route path="/bazar" element={<P><Bazar /></P>} />
          <Route path="/bazar/compare" element={<P><BazarCompare /></P>} />
          <Route path="/bazar/:eventId" element={<P><Bazar /></P>} />
          <Route path="/sales/preorder-ready" element={<P><PreOrderReady /></P>} />
          <Route path="/sales/preorder-warehouse" element={<P><PreOrderWarehouse /></P>} />
          <Route path="/sales/preorder-keep-create" element={<P><CreateKeepPO /></P>} />
          <Route path="/sales/preorder-keep/edit/:id" element={<P><CreateKeepPO /></P>} />
          <Route path="/sales/preorder/overview" element={<P><PreOrderOverview /></P>} />
          <Route path="/sales/preorder/analysis" element={<P><PreOrderAnalysis /></P>} />
          <Route path="/sales/preorder/production" element={<P><PreOrderProduction /></P>} />
          <Route path="/sales/picking" element={<P><ComingSoon title="Picking & Packing" /></P>} />
          <Route path="/sales/shipping" element={<P><ShippingSale /></P>} />
          {/* Marketplace */}
          <Route path="/marketplace/connection" element={<P><ComingSoon title="Marketplace Connection" /></P>} />
          <Route path="/marketplace/mapping" element={<P><ComingSoon title="Mapping Produk Marketplace" /></P>} />
          <Route path="/marketplace/orders" element={<P><ComingSoon title="Marketplace Orders" /></P>} />
          <Route path="/marketplace/settlement" element={<P><ComingSoon title="Settlement/Withdrawal" /></P>} />
          {/* Return */}
          <Route path="/return/customer" element={<P><CustomerReturns /></P>} />
          <Route path="/return/supplier" element={<P><ComingSoon title="Return Supplier" /></P>} />
          {/* Inventory */}
          <Route path="/inventory/categories" element={<P><MasterSimple kind="categories" title="Category" hasCode={false} /></P>} />
          <Route path="/inventory/colors" element={<P><MasterSimple kind="colors" title="Colour" hasCode={true} /></P>} />
          <Route path="/inventory/sizes" element={<P><MasterSimple kind="sizes" title="Size" hasCode={true} /></P>} />
          <Route path="/inventory/labels" element={<P><ProductLabels /></P>} />
          <Route path="/inventory/adjustment" element={<P><ComingSoon title="Stock Adjustment" /></P>} />
          <Route path="/inventory/forecast" element={<P><RestockPlanning /></P>} />
          <Route path="/inventory/opname" element={<P><Opname /></P>} />
          <Route path="/inventory/asset-report" element={<P><AssetReport /></P>} />
          {/* Master Data */}
          <Route path="/master/customer" element={<P><Customers /></P>} />
          <Route path="/master/customer-group" element={<P><CustomerGroups /></P>} />
          <Route path="/master/discount" element={<P><ComingSoon title="Discount" /></P>} />
          <Route path="/master/payment-methods" element={<P><PaymentMethods /></P>} />
          <Route path="/printer" element={<P><PrinterSettings /></P>} />
          {/* Finance */}
          <Route path="/finance/cost" element={<P><ComingSoon title="Cost" /></P>} />
          <Route path="/finance/expense" element={<P><ComingSoon title="Expense" /></P>} />
          <Route path="/finance/settlement" element={<P><MarketplaceSettlement /></P>} />
          <Route path="/stock-history/:variantId" element={<ProtectedRoute bare><StockHistory /></ProtectedRoute>} />
          <Route path="/finance/shipping-reconciliation" element={<P><MarketplaceShippingReconciliation /></P>} />
          <Route path="/finance/reconciliation-control-center" element={<P><ReconciliationControlCenter /></P>} />
          <Route path="/finance/online-report-coverage" element={<P><OnlineReportCoverage /></P>} />
          <Route path="/finance/marketplace-mapping" element={<P><MarketplaceMapping /></P>} />
          <Route path="/finance/rab" element={<P><RabRequests /></P>} />
          <Route path="/finance/rab/:section" element={<P><RabRequests /></P>} />

          {/* Produksi (Sprint 3) */}
          <Route path="/production/dashboard" element={<P><ProductionDashboard /></P>} />
          <Route path="/production/plans" element={<P><ProductionPlans /></P>} />
          <Route path="/production/plans/new" element={<P><PlanWizardPage /></P>} />
          <Route path="/production/bom" element={<P><BOM /></P>} />
          <Route path="/production/products" element={<P><ProductProductionHistory /></P>} />
          <Route path="/production/fabrics" element={<P><Fabrics /></P>} />
          <Route path="/production/accessories" element={<P><Accessories /></P>} />
          <Route path="/production/material-purchases" element={<P><MaterialPurchases /></P>} />
          <Route path="/production/restock-proposals" element={<P><RestockProposals /></P>} />
          <Route path="/production/cutting" element={<P><Cutting /></P>} />
          <Route path="/production/orders" element={<P><ProductionOrders /></P>} />
          <Route path="/production/kanban" element={<P><ProductionKanban /></P>} />
          <Route path="/production/receiving" element={<P><ProductionReceiving /></P>} />
          <Route path="/production/receiving-hub" element={<P><ReceivingHub /></P>} />
          <Route path="/production/wip" element={<P><WIP /></P>} />
          <Route path="/production/fabric-returns" element={<P><FabricReturns /></P>} />
          <Route path="/production/defects" element={<P><ComingSoon title="Defect & Rework" /></P>} />
          <Route path="/production/visits" element={<P><ComingSoon title="Jadwal Kunjungan" /></P>} />
          <Route path="/production/reports" element={<P><ProductionReport /></P>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
